// ATCD Adulte
import ATCDAdultePersonnel from '@/views/consultations/en-cours/antecedent-adulte-personnel'
import ATCDAdulteFamiliaux from '@/views/consultations/en-cours/antecedent-adulte-familiaux'

export default {
    name: 'recap-dmp',
    components: {
        ATCDAdultePersonnel, ATCDAdulteFamiliaux
    },
    props: {
        type_consultation_id: Number
    },
    data() {
        return {
            global_dmp_loading: true,
            type_dmp_loading: true,
            type_dmp_is_empty: false,
            can_see_atcd: false,
            is_old_atcd: true,
        }
    },
    computed: {
        all_patient_dmp() {
            return this.$store.getters['all_patient_dmp']
        },
    },
    mounted() {
        this.refreshConsultationTypeDmp()
    },
    methods: {
        refreshConsultationTypeDmp() {
            this.$store.commit("SET_ALL_PATIENT_DMP", [])
            this.global_dmp_loading = true
            const data = {
                type_consultation_id: this.type_consultation_id,
                patient_id: this.$route.params.id
            }
            this.$store.dispatch('getAllPatientDmp', data).then(() => {
                this.global_dmp_loading = false
            })
        },

        editer(dmp) {
            const type_dmp = dmp.type_dmp
            this.$emit('changeView', { info_dmp: dmp, type_dmp: type_dmp, is_edit: true })
        }
    }
}